import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface TaskMarkdownProps {
  readonly source: string;
}

const TaskMarkdown: React.FC<TaskMarkdownProps> = ({ source }) => (
  <div className="task-markdown">
    <ReactMarkdown remarkPlugins={[remarkGfm]}>{source}</ReactMarkdown>
  </div>
);

export default TaskMarkdown;
